import type {SxProps, Theme} from '@mui/material';

// On mobile the outer "parent" card that wraps inner cards is flattened (no border, background or
// padding) so only the inner cards show. The theme's MuiCardContent forces white, so it is reset too.
// Desktop keeps the standard outlined card.
export const flatOuterCardSx = (isMobile: boolean, desktop: SxProps<Theme> = {borderRadius: 1}): SxProps<Theme> =>
    isMobile
        ? {border: 0, boxShadow: 'none', backgroundColor: 'transparent', backgroundImage: 'none', overflow: 'visible', '&:hover': {boxShadow: 'none'}}
        : desktop;

export const flatOuterCardContentSx = (isMobile: boolean): SxProps<Theme> | undefined =>
    isMobile ? {p: 0, backgroundColor: 'transparent', '&:last-child': {pb: 0}} : undefined;
